export enum LayoutDeskType {
    Basic = 1,
    Office = 2,
    ByHourCategory = 4
}